import { Link } from 'react-router-dom'
import { Page } from '@/components/layout/Page'
import { Status } from '@/components/common/Status'
import { CompassIcon } from '@/components/common/icons'

export function NotFoundPage() {
  return (
    <Page>
      <Status
        tone="warn"
        icon={<CompassIcon />}
        title={<span data-testid="route-label">404 &mdash; page not found</span>}
        actions={
          <Link className="btn" to="/">
            Go to the Lobby
          </Link>
        }
      >
        That link doesn&rsquo;t point anywhere in the Lobby.
      </Status>
    </Page>
  )
}
